import { AnnouncementsService } from "../services"

export const getFeaturedAnnouncements = (uid) => {
    return AnnouncementsService
        .getFeaturedAnnouncements()
        .get()
        .then(response => {
            return response.docs.length ? response.docs.map(item => ({
                    ...item.data(),
                    id: item.id,
                    type: 'announcement'
                })) : []
        })
}